var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 619 323.5",
    style: {
      enableBackground: "new 0 0 619 323.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M602.6,159.5c0-0.2,0-0.5,0-0.8c0-1.5-0.2-2.9-0.5-4.3v0.1c-0.6-1.6-2.1-2.5-3.1-3.8c-0.5-0.7-0.3-1.7-1-2.3 l-125-125c-3.4-3.4-8.1-5.6-13.3-5.6c-10.4,0-18.8,8.4-18.8,18.8c0,5.2,2.1,9.9,5.5,13.3l93,93H34.8c-10.4,0-18.8,8.4-18.8,18.8 s8.4,18.8,18.8,18.8l0,0h504.7l-93,93c-3.4,3.4-5.5,8.1-5.5,13.3c0,10.4,8.4,18.8,18.8,18.8c5.2,0,9.9-2.1,13.3-5.5l125-125 c2.9-3.1,4.7-7.3,4.9-11.8l0,0c0-0.1,0-0.2,0-0.3C602.9,161.7,602.8,160.6,602.6,159.5L602.6,159.5L602.6,159.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.97cac072baf47439b43e06224a455d20.svg";
export { ForwardRef as ReactComponent };